import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { MenuActionItem } from './styles';
const styledMenuActionItemCss = "sfz04fz";
const StyledMenuActionItem = forwardRef((props, ref) => <MenuActionItem ref={ref} {...props} className={classNames(styledMenuActionItemCss, props.className)} />);
const ShowMoreGroups = ({
  label,
  onClick,
  show
}) => <StyledMenuActionItem show={show}>
    <BareButton onClick={onClick}>
      {label}
    </BareButton>
  </StyledMenuActionItem>;
export default ShowMoreGroups;

require("./show_more_groups.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./show_more_groups.js");